export default "__VITE_ASSET__BA6nQ_Ut__"